import { Component, Input, OnInit } from "@angular/core";
import { AppLeague } from "@shared/models/league";
import { TeamService } from "@core/services/team.service";
import { LeagueService } from "@core/services/league.service";
import { TypeService } from "@core/services/type.service";
import { PageType } from "../../../../../page-type";
import { AdCampaignService } from "@components/ad-campaign/services/ad-campaign.service";
import { AdCampaignPlacement } from "@api/models/ad-campaign/ad-campaign-placement";
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: "app-team-table",
  templateUrl: "./team-table.component.html",
  styleUrls: [
    "./team-table.component.scss",
    "./team-table-inLeaguePages.component.scss",
  ],
})
export class TeamTableComponent implements OnInit {
  public league: AppLeague;
  public showLeagueLinkInTable: boolean = false;
  public isLeaguePage = false;

  protected readonly EntityType = EntityType;

  constructor(
    public teamService: TeamService,
    public leagueService: LeagueService,
    private adCampaignService: AdCampaignService
  ) {}

  public ngOnInit() {
    let leagueId: string;
    if (TypeService.pageType === PageType.Team) {
      leagueId = this.teamService.currentTeam.getLeagueForTable();
      this.adCampaignService.setPlacement(AdCampaignPlacement.Table);
    }
    if (TypeService.pageType === PageType.League) {
      leagueId = this.leagueService.getCurrentLeagueId();
      this.adCampaignService.setPlacement(AdCampaignPlacement.Table);
      this.isLeaguePage = true;
    }

    if (leagueId) {
      this.getLeagueTableFromLeagueId(leagueId);
    }
    this.showLeagueLinkInTable = TypeService.pageType === PageType.Team;
  }

  public onEmptyTable(): void {
    this.league = null;
  }

  private getLeagueTableFromLeagueId(leagueIdForTable: string) {
    this.leagueService.getLeague(leagueIdForTable).then((league) => {
      if (league == null) {
        this.league = null;
        return;
      }
      this.league = league;
    });
  }
}
